import { api, apiAuth, apiResponseType } from ".";
import { PaymentAdvanceStoreParams, PaymentAdvanceUpdateParams } from "@/types/paymentAdvance";

export interface PaymentAdvanceFiltersParams {
  client_id?: string;
  seller_id?: string;
  status?: string;
  start_date?: string;
  end_date?: string;
  linked?: string;
  sale_id?: string;
  id?: string;
  order_by?: string;
  order_direction?: "asc" | "desc";
}

export const getPaymentAdvances = (
  page: number = 1,
  params?: PaymentAdvanceFiltersParams
): apiResponseType => {
  const queryParams = new URLSearchParams();
  queryParams.append("page", page.toString());

  if (params?.client_id && params.client_id !== "all") {
    queryParams.append("client_id", params.client_id);
  }

  if (params?.seller_id && params.seller_id !== "all") {
    queryParams.append("seller_id", params.seller_id);
  }

  if (params?.status && params.status !== "all") {
    queryParams.append("status", params.status);
  }

  if (params?.start_date) {
    queryParams.append("start_date", params.start_date);
  }

  if (params?.end_date) {
    queryParams.append("end_date", params.end_date);
  }

  if (params?.linked && params.linked !== "all") {
    queryParams.append("linked", params.linked);
  }

  if (params?.sale_id && params.sale_id !== "all" && params.sale_id !== "") {
    queryParams.append("sale_id", params.sale_id);
  }

  if (params?.id && params.id !== "" && params.id !== "all") {
    queryParams.append("id", params.id);
  }

  if (params?.order_by) {
    queryParams.append("order_by", params.order_by);
  }

  if (params?.order_direction) {
    queryParams.append("order_direction", params.order_direction);
  }

  return apiAuth.get(`payment-advances?${queryParams.toString()}`) as apiResponseType;
};

export const updatePaymentAdvanceClient = (
  uuid: string,
  client_id: number
): apiResponseType => {
  return apiAuth.put(`payment-advances/${uuid}/update`, { client_id }) as apiResponseType;
};

export const createPaymentAdvance = (
  data: PaymentAdvanceStoreParams
): apiResponseType => {
  return apiAuth.post("payment-advances/store", data) as apiResponseType;
};

export const showPaymentAdvance = (uuid: string): apiResponseType => {
  return apiAuth.get(`payment-advances/${uuid}/show`) as apiResponseType;
};

export const updatePaymentAdvance = (
  uuid: string,
  data: PaymentAdvanceUpdateParams
): apiResponseType => {
  return apiAuth.put(`payment-advances/${uuid}/update`, data) as apiResponseType;
};

export const deletePaymentAdvance = (uuid: string): apiResponseType => {
  return apiAuth.delete(`payment-advances/${uuid}/destroy`) as apiResponseType;
};

export const getSelectPaymentAdvances = (params?: {
  client_id?: number;
  seller_id?: number;
}): apiResponseType => {
  const queryParams = new URLSearchParams();

  if (params?.client_id) {
    queryParams.append("client_id", params.client_id.toString());
  }

  if (params?.seller_id) {
    queryParams.append("seller_id", params.seller_id.toString());
  }

  const queryString = queryParams.toString();
  const url = queryString ? `payment-advances/select?${queryString}` : "payment-advances/select";

  return apiAuth.get(url) as apiResponseType;
};

export const checkPaymentAdvanceStatus = (uuid: string): apiResponseType => {
  return apiAuth.get(`payment-advances/${uuid}/check-payment-status`) as apiResponseType;
};

export const publicShowPaymentAdvance = (uuid: string): apiResponseType => {
  return api.get(`payment-advances/public/${uuid}/show`) as apiResponseType;
};

export const publicCheckPaymentAdvanceStatus = (uuid: string): apiResponseType => {
  return api.get(`payment-advances/public/${uuid}/check-payment-status`) as apiResponseType;
};

export const convertPaymentAdvanceToBalance = (uuid: string): apiResponseType => {
  return apiAuth.post(`payment-advances/${uuid}/convert-to-balance`) as apiResponseType;
};
